
import { Component, Prop, Vue } from "vue-property-decorator";
import UdcBannerGeneric from "@/components/UdcBannerGeneric.vue";

@Component({
  name: "celebrus-vignettes-fiche-produit",
  components: {
    UdcBannerGeneric
  }
})
export default class CelebrusVignettesFicheProduit extends Vue {
  @Prop() private banner!: any;
  @Prop() private methods!: any;

  private getProvenanceName() {
    if (this.banner.message_id) {
      return this.banner.message_id.match(/BAN_SECOURS/)
        ? "emergencyBanner"
        : "rtim";
    } else {
      return "rtim";
    }
  }

  private async onCloseClick() {
    if (this.getCrossReponse()) {
      this.banner.celebrusHelper.custom(this.getCrossReponse());
    } else {
      this.banner.celebrusHelper.refused();
    }
    window.dispatchEvent(
      new CustomEvent(`rtim-banner:${this.banner.location}`, {
        detail: {
          content: {emplacement: "celebrus-vignettes-fiche-produit", nom_gabarit: "Gab20"},
          placement: {
            id: this.banner.location,
            size: "1260x630",
            zone: "udc-top"
          }
        }
      })
    );
  }
  private getCrossReponse() {
    return this.banner.crossAnswer;
  }
}
